export default "__VITE_ASSET__DuqWoCiT__"